<template>
  <a-modal
    :visible="visible"
    :title="params.type"
    @ok="submit"
    @cancel="cancel"
    width="800px"
  >
    <a-form :form="form">
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="资源名称"
      >
        <a-input
          v-decorator="[
            'resourName',
            { rules: [{ required: false, message: '请输入资源名称' }] }
          ]"
          disabled
        ></a-input>
      </a-form-item>
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="资源分类"
      >
        <a-tree-select
          v-decorator="[
            'resourType',
            { rules: [{ required: true, message: '请选择资源分类' }] }
          ]"
          :replaceFields="{
            title: 'name',
            key: 'id',
            value: 'id',
            children: 'jtypes'
          }"
          :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
          :treeData="types"
          @change="onTypeChange"
        >
        </a-tree-select>
      </a-form-item>

      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="教师姓名"
      >
        <Authorized :authority="['RESOURCE_TEACHER_NAME']">
          <a-select
            show-search
            v-decorator="['uploadPerson']"
            placeholder="请选择上传人员"
            option-filter-prop="children"
            style="width: 100%"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in users"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </Authorized>
        <UnAuthorized :authority="['RESOURCE_TEACHER_NAME']">
          <a-select
            v-decorator="[
              'uploadPerson',
              {
                initialValue: user.userid
              }
            ]"
            placeholder="请选择上传人员"
          >
            <a-select-option :key="user.userid" :value="user.userid">
              {{ user.name }}
            </a-select-option>
          </a-select>
        </UnAuthorized>
      </a-form-item>

      <a-form-item
        label="上传附件"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-upload
          v-decorator="[
            'resourUrl',
            {
              valuePropName: 'file',
              getValueFromEvent: uploadHead,
              rules: [{ required: true, message: '请选择需要上传的资源' }]
            }
          ]"
          name="files"
          :multiple="false"
          :action="uploadURL"
          :headers="headers"
          :file-list="fileList"
          @change="handleChange"
        >
          <a-button> <a-icon type="upload" />上传文件</a-button>
        </a-upload>
      </a-form-item>
      <!-- <a-form-item
        v-if="params.visible"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="是否对外展示"
      >
        <a-radio-group
          v-decorator="[
            'isPreview',
            {
              initialValue: value,
              rules: [{ required: true, message: '请选择是否对外展示' }],
            },
          ]"
          name="radioGroup"
        >
          <a-radio value="0" :click="check(0)">否</a-radio>
          <a-radio value="1" :click="check(1)">是</a-radio>
        </a-radio-group>
      </a-form-item> -->
    </a-form>
  </a-modal>
</template>
<script>
import storage from "store";
import { USER, USER_TOKEN } from "@/store/mutation-types";
import { trees } from "@/api/base/tree/manager";
import { del } from "@/api/base/resource/manager";
import { findAll } from "@/api/system/user";
import { save } from "@/api/base/resource/manager";
import { UPLOAD_WARNING_MESSAGE } from "@/constants/upload";
import { getTypeNamesById } from "@/utils/treeTypeUtil";
import { pick } from "lodash";

export default {
  name: "uploadModal",
  props: { params: Object },
  data() {
    return {
      //modal
      visible: false,
      //form
      form: this.$form.createForm(this),
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      resources: {}, //对象
      types: [], //分类树
      fileId: "",
      fileName: "",
      users: [],
      // upload
      uploadURL: window._CONFIG["uploadURL"], // 上传路径
      headers: { user_token: storage.get(USER_TOKEN) },
      user: storage.get(USER),
      fileList: [],
      value: "0",
      id: ""
    };
  },
  created() {
    trees().then(res => {
      this.types = res.result;
    });
    findAll().then(res => {
      this.users = res.result;
    });
  },
  methods: {
    handleChange(info) {
      console.log("info", info);
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;
      console.log("this.fileList", this.fileList);
    },
    check(val) {
      this.checked = val;
    },

    //文件上传
    uploadHead({ file }) {
      console.log("file", file);
      if (file.status == "uploading") {
        return;
      }
      if (file.status == "done") {
        if (file) {
          del({ ids: this.params.id }).then();
        }
        if (0 == file.response.resultCode) {
          this.$notification.warning({
            message: UPLOAD_WARNING_MESSAGE
          });
          console.log(" === upload error:", file.response.message);
          this.form.setFieldsValue({ resourName: "" });
          this.fileId = "";
          this.fileName = "";
          this.fileList = [];
          return "";
        } else if (1 == file.response.resultCode) {
          // debugger;
          let resourName = file.response.result[0].fileName;
          let resourType = this.form.getFieldValue("resourType");
          if (resourType) {
            resourName =
              getTypeNamesById(this.types, resourType) + "_" + resourName;
          }
          this.form.setFieldsValue({ resourName: resourName });
        }

        let path = file.response.result[0].filePath;
        this.fileId = file.response.result[0].id;
        this.fileName = file.response.result[0].fileName;
        return path;
      }
    },

    show(params) {
      this.visible = true;
      if (params) {
        console.log("params", params);
        if (this.params.type == "编辑") {
          this.$nextTick(() => {
            this.resourId = params.resourId;
            this.id = this.params.fileId;
            this.fileList = [
              {
                name: params.resourName,
                url: params.resourUrl,
                uid: "1",
                status: "done"
              }
            ];
            // console.log('this.fileList', this.fileList)
            let gain = pick(params, "resourName", "resourType", "resourUrl");
            // 等待页面加载完后设置数据
            this.form.setFieldsValue(gain);
          });
        }
      }
    },

    cancel() {
      this.visible = false;
      this.params.resourName = "";
      this.form.resetFields();
      this.fileId = "";
      this.fileList = [];
      this.params.name = "";
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          let fileData = null;
          if (this.params.type == "编辑") {
            console.log("this.parmas", this.parmas);
            fileData = Object.assign(values, {
              resourId: this.resourId,
              id: this.id
            });
          } else {
            fileData = Object.assign(values, { resourId: this.fileId });
          }
          console.log("上传保存值：", fileData);
          let params = Object.assign(this.resources, fileData);
          params.isPreview = "0";
          console.log("params", params);
          save({ ...params }).then(res => {
            this.$notification.success({
              message: res.message
            });
            this.params = {};
            this.loading = false;
            this.cancel();
            this.$emit("refreshWord");
          });
        }
      });
    },
    onTypeChange(value) {
      // console.log(value);
      // console.log(label);
      // console.log(extra);
      // console.log("this.fileList", this.fileList);

      // console.log("file", file);
      if (this.params.type == "编辑") {
        const fileList = this.fileList[0].name.split("_");
        const len = fileList.length;
        const file = fileList[len - 1];
        this.form.setFieldsValue({
          resourName: getTypeNamesById(this.types, value) + "_" + file
        });
      }
      if (this.fileName) {
        this.form.setFieldsValue({
          resourName: getTypeNamesById(this.types, value) + "_" + this.fileName
        });
      }
    }
  }
};
</script>
<style></style>
